import React from 'react'
import Layout from 'common/Layout'
import Seo from 'common/Seo'
import { graphql } from 'gatsby'
import useContentfulPage from 'hooks/useContentfulPage'

import ResellersHero from 'sections/resellers/ResellersHero'

import ResellersWhyXeal from 'sections/resellers/ResellersWhyXeal'
import XealProvides from 'sections/resellers/XealProvides'
import ResellerQuote from 'sections/resellers/ResellerQuote'
import HowWeSupportYou from 'sections/resellers/HowWeSupportYou'
import LatestEvInsights from 'sections/resellers/LatestEvInsights'
import GetXealCertified from 'sections/resellers/GetXealCertified'
import BecomeAXealPartner from 'sections/resellers/BecomeAXealPartner'
import useMeta from '../components/hooks/useMeta'
import TrustedByGrid from '../components/sections/home/TrustedByGrid/TrustedByGrid'

const ResellersPage = ({ data: { page } }) => {
  const {
    resellers_hero,
    proven_industries_grid,
    resellers_why_xeal,
    xeal_provides,
    reseller_quote,
    how_we_support_you,
    latest_ev_insights,
    get_xeal_certified,
    become_a_xeal_partner,
  } = useContentfulPage(page)

  return (
    <Layout theme="dark">
      <ResellersHero {...resellers_hero} />
      <TrustedByGrid {...proven_industries_grid} />

      <ResellersWhyXeal {...resellers_why_xeal} />
      <XealProvides {...xeal_provides} />
      <ResellerQuote {...reseller_quote} />
      <HowWeSupportYou {...how_we_support_you} />
      <LatestEvInsights {...latest_ev_insights} />
      <GetXealCertified {...get_xeal_certified} />
      <BecomeAXealPartner {...become_a_xeal_partner} />
    </Layout>
  )
}

export default ResellersPage

export const Head = ({ location, data: { page } }) => {
  const meta = useMeta(page)

  return <Seo {...meta} pathname={location.pathname} />
}

export const query = graphql`
  {
    page: contentfulPage(pageID: { eq: "resellers" }) {
      ...Page
    }
  }
`
